import INFTProperties from '../../../models/INFTProperties'

export enum NFTFileFormatsEnum {
  VIDEO,
  IMAGE,
  AUDIO
}

export const NFTFileFormats: {
  [key: string]: NFTFileFormatsEnum
} = {
  video: NFTFileFormatsEnum.VIDEO,
  audio: NFTFileFormatsEnum.AUDIO,
  image: NFTFileFormatsEnum.IMAGE
}

export interface IDefaultCard {
  name: string
  image: string
  coverImage: string
  type: NFTFileFormatsEnum
  description: string
  externalUrl: string
  attributes: INFTProperties[]
}
